<template>
    <pg-page title="Private Gym Foto's"
             header="Fotos"
             subtitle="In het echt is de gym nog veel mooier"
             id="fotos"
    >

        <div class="row">
            <div class="col-sm-4 my-4">
                <div class="card bg-dark text-white">
                    <img src="/images/gym/1.jpeg" class="card-img"
                         alt="Private Gym personal training">
                </div>
            </div>
            <div class="col-sm-4 my-4">
                <div class="card bg-dark text-white">
                    <img src="/images/gym/4.jpeg" class="card-img"
                         alt="Private Gym personal training">
                </div>
            </div>
            <div class="col-sm-4 my-4">
                <div class="card bg-dark text-white">
                    <img src="/images/gym/5.jpeg" class="card-img"
                         alt="Private Gym personal training">
                </div>
            </div>
            <div class="col-sm-4 my-4">
                <div class="card bg-dark text-white">
                    <img src="/images/gym/6.jpeg" class="card-img"
                         alt="Private Gym personal training">
                </div>
            </div>
            <div class="col-sm-4 my-4">
                <div class="card bg-dark text-white">
                    <img src="/images/gym/2.jpeg" class="card-img"
                         alt="Private Gym personal training">
                </div>
            </div>
            <div class="col-sm-4 my-4">
                <div class="card bg-dark text-white">
                    <img src="/images/gym/7.jpeg" class="card-img"
                         alt="Private Gym personal training">
                </div>
            </div>
            <div class="col-sm-4 my-4">
                <div class="card bg-dark text-white">
                    <img src="/images/gym/8.jpeg" class="card-img"
                         alt="Private Gym personal training">
                </div>
            </div>
            <div class="col-sm-4 my-4">
                <div class="card bg-dark text-white">
                    <img src="/images/gym/9.jpeg" class="card-img"
                         alt="Private Gym personal training">
                </div>
            </div>
            <div class="col-sm-4 my-4">
                <div class="card bg-dark text-white">
                    <img src="/images/gym/10.jpeg" class="card-img"
                         alt="Private Gym personal training">
                </div>
            </div>
            <div class="col-sm-4 my-4">
                <div class="card bg-dark text-white">
                    <img src="/images/gym/11.jpeg" class="card-img"
                         alt="Private Gym personal training">
                </div>
            </div>
            <div class="col-sm-4 my-4">
                <div class="card bg-dark text-white">
                    <img src="/images/gym/12.jpeg" class="card-img"
                         alt="Private Gym personal training">
                </div>
            </div>
            <div class="col-sm-4 my-4">
                <div class="card bg-dark text-white">
                    <img src="/images/gym/13.jpeg" class="card-img"
                         alt="Private Gym personal training">
                </div>
            </div>
            <div class="col-sm-4 my-4">
                <div class="card bg-dark text-white">
                    <img src="/images/gym/14.jpeg" class="card-img"
                         alt="Private Gym personal training">
                </div>
            </div>
            <div class="col-sm-4 my-4">
                <div class="card bg-dark text-white">
                    <img src="/images/gym/15.jpeg" class="card-img"
                         alt="Private Gym personal training">
                </div>
            </div>
            <div class="col-sm-4 my-4">
                <div class="card bg-dark text-white">
                    <img src="/images/gym/16.jpeg" class="card-img"
                         alt="Private Gym personal training">
                </div>
            </div>
            <div class="col-sm-4 my-4">
                <div class="card bg-dark text-white">
                    <img src="/images/gym/17.jpeg" class="card-img"
                         alt="Private Gym personal training">
                </div>
            </div>
            <div class="col-sm-4 my-4">
                <div class="card bg-dark text-white">
                    <img src="/images/gym/18.jpeg" class="card-img"
                         alt="Private Gym personal training">
                </div>
            </div>
            <div class="col-sm-4 my-4">
                <div class="card bg-dark text-white">
                    <img src="/images/gym/19.jpeg" class="card-img"
                         alt="Private Gym personal training">
                </div>
            </div>
            <div class="col-sm-4 my-4">
                <div class="card bg-dark text-white">
                    <img src="/images/gym/20.jpeg" class="card-img"
                         alt="Private Gym personal training">
                </div>
            </div>
            <div class="col-sm-4 my-4">
                <div class="card bg-dark text-white">
                    <img src="/images/gym/21.jpeg" class="card-img"
                         alt="Private Gym personal training">
                </div>
            </div>
            <div class="col-sm-4 my-4">
                <div class="card bg-dark text-white">
                    <img src="/images/gym/22.jpeg" class="card-img"
                         alt="Private Gym personal training">
                </div>
            </div>
            <div class="col-sm-4 my-4">
                <div class="card bg-dark text-white">
                    <img src="/images/gym/23.jpeg" class="card-img"
                         alt="Private Gym personal training">
                </div>
            </div>
        </div>



        <div class="row">
            <div class="col my-5 py-5 text-center">
                <h1 class="mb-5">
                    <strong>
                        Kom zelf kijken! Plan een rondleiding of stel je vraag via Whatsapp!
                    </strong>
                </h1>
                <action-buttons :show-whatsapp="true" :show-inschrijven="false" :colored="true" :icon="true"></action-buttons>
            </div>
        </div>
    </pg-page>
</template>

<script>

import PgPage from "../Components/PgPage";
import ContactModal from "../Components/Contact/ContactModal";
import ActionButtons from "../Components/Index/ActionButtons";
export default {
    components: {ActionButtons, ContactModal, PgPage},

    props: [],

    mixins: [],

    data: function () {
        return {
            showFormModal: false,
        };
    },

    computed: {
        //
    },

    created() {
        //
    },

    mounted() {
        //
    },

    methods: {
        //
    },

    watch: {
        //
    }
};
</script>
<style>
.instagram{
    border-color: rgba(0,0,0,0);
    background: #f09433;
    background: -moz-linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%);
    background: -webkit-linear-gradient(45deg, #f09433 0%,#e6683c 25%,#dc2743 50%,#cc2366 75%,#bc1888 100%);
    background: linear-gradient(45deg, #f09433 0%,#e6683c 25%,#dc2743 50%,#cc2366 75%,#bc1888 100%);
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#f09433', endColorstr='#bc1888',GradientType=1 );
}
</style>
